import { BrandsTrims } from "../brands-trims.entity";
import { MasterBrand } from "../master-brands.entity";
import { MasterBrandDTO } from "./master-brands.dto";

export class MasterBrandAdapter {
    convertDtoToEntity(dtoObj: MasterBrandDTO,  isUpdate: boolean = false ): MasterBrand {
        try {
            console.log('dtoObj')
            console.log('*************************',dtoObj)
            
            const entityObj = new MasterBrand();
           if (dtoObj.masterBrandId) {
                entityObj.masterBrandId = Number(dtoObj.masterBrandId);
                entityObj.updatedUser = dtoObj.updatedUser;
                entityObj.createdUser = dtoObj.createdUser;
            }else{
                entityObj.createdUser = dtoObj.createdUser;
            }
            if(dtoObj.isPouchGradeConsider == 'true'){
                entityObj.isPouchGradeConsider=true
            }else{
                entityObj.isPouchGradeConsider=false
            }
           if(dtoObj.isPouchBapNoConsider == 'true'){
                entityObj.isPouchBapNoConsider=true
            }else{
                entityObj.isPouchBapNoConsider=false
            }
            if(dtoObj.isPouchVariantConsider=='true'){
                entityObj.isPouchVariantConsider=true
            }else{
                entityObj.isPouchVariantConsider=false
            }
            if(dtoObj.isPouchValAddOneConsider=='true'){
                entityObj.isPouchValAddOneConsider=true
            }else{
                entityObj.isPouchValAddOneConsider=false
            }
            if(dtoObj.isPouchValAddTwoConsider=='true'){
                entityObj.isPouchValAddTwoConsider=true
            }else{
                entityObj.isPouchValAddTwoConsider=false
            }
            if(dtoObj.isPouchValAddThreeConsider=='true'){
                entityObj.isPouchValAddThreeConsider=true
            }else{
                entityObj.isPouchValAddThreeConsider=false
            }
            if(dtoObj.isPouchValAddFourConsider=='true'){
                entityObj.isPouchValAddFourConsider=true
            }else{
                entityObj.isPouchValAddFourConsider=false
            }
            if(dtoObj.isPouchValAddFiveConsider=='true'){
                entityObj.isPouchValAddFiveConsider=true
            }else{
                entityObj.isPouchValAddFiveConsider=false
            }
            if(dtoObj.isPouchFoodTypeConsider=='true'){
                entityObj.isPouchFoodTypeConsider=true
            }else{
                entityObj.isPouchFoodTypeConsider=false
            }
            if(dtoObj.isPouchProductConsider=='true'){
                entityObj.isPouchProductConsider=true
            }else{
                entityObj.isPouchProductConsider=false
            }
            if(dtoObj.isCartonBapNoConsider=='true'){
                entityObj.isCartonBapNoConsider=true
            }else{
                entityObj.isCartonBapNoConsider=false
            }
            if(dtoObj.isCartonGradeConsider=='true'){
                entityObj.isCartonGradeConsider=true
            }else{
                entityObj.isCartonGradeConsider=false
            }
            if(dtoObj.isCartonVariantConsider=='true'){
                entityObj.isCartonVariantConsider=true
            }else{
                entityObj.isCartonVariantConsider=false
            }
            if(dtoObj.isCartonValAddOneConsider=='true'){
                entityObj.isCartonValAddOneConsider=true
            }else{
                entityObj.isCartonValAddOneConsider=false
            }
            if(dtoObj.isCartonValAddTwoConsider=='true'){
                entityObj.isCartonValAddTwoConsider=true
            }else{
                entityObj.isCartonValAddTwoConsider=false
            }
            if(dtoObj.isCartonValAddThreeConsider=='true'){
                entityObj.isCartonValAddThreeConsider=true
            }else{
                entityObj.isCartonValAddThreeConsider=false
            }
            if(dtoObj.isCartonValAddFourConsider=='true'){
                entityObj.isCartonValAddFourConsider=true
            }else{
                entityObj.isCartonValAddFourConsider=false
            }
            if(dtoObj.isCartonValAddFiveConsider=='true'){
                entityObj.isCartonValAddFiveConsider=true
            }else{
                entityObj.isCartonValAddFiveConsider=false
            }
            if(dtoObj.isCartonFoodTypeConsider=='true'){
                entityObj.isCartonFoodTypeConsider=true
            }else{
                entityObj.isCartonFoodTypeConsider=false
            }
            if(dtoObj.isCartonProductConsider=='true'){
                entityObj.isCartonProductConsider=true
            }else{
                entityObj.isCartonProductConsider=false
            }
            entityObj.masterBrandName = dtoObj.masterBrandName;
            entityObj.filePath = dtoObj.filePath;
            entityObj.fileName = dtoObj.fileName;
            
            entityObj.isActive = dtoObj.isActive;
            entityObj.displayBrandName = dtoObj.displayBrandName
           if(dtoObj.trimsInfo){
               
           
            const brandsTrimsObj : BrandsTrims[] = []
            for(const dto of dtoObj.trimsInfo ){
                const newObj = new BrandsTrims()
                newObj.masterBrandId = dtoObj.masterBrandId;
                newObj.trimsId = dto.trimsId;
               if(dto.brandsTrimsId){
                   newObj.brandsTrimsId = dto.brandsTrimsId
               }
               brandsTrimsObj.push(newObj)
    
            }
            entityObj.trimsInfo = brandsTrimsObj
            return entityObj;
        }
        } catch (Error) {
            return Error;
        }
    }

    public convertEntityToDto(brandObject: MasterBrand): MasterBrandDTO {
        const masterBrandDTO= new MasterBrandDTO;
        masterBrandDTO.masterBrandId = brandObject.masterBrandId;
        masterBrandDTO.masterBrandName = brandObject.masterBrandName;
        masterBrandDTO.filePath = brandObject.filePath;
        masterBrandDTO.fileName = brandObject.fileName;
        if(brandObject.isPouchGradeConsider == true){
            masterBrandDTO.isPouchGradeConsider='true'
        }
       if(brandObject.isPouchBapNoConsider == true){
            masterBrandDTO.isPouchBapNoConsider='true'
        }else{
            masterBrandDTO.isPouchBapNoConsider='false'
        }
        if(brandObject.isPouchVariantConsider==true){
            masterBrandDTO.isPouchVariantConsider='true'
        }else{
            masterBrandDTO.isPouchVariantConsider='false'
        }
        if(brandObject.isPouchValAddOneConsider==true){
            masterBrandDTO.isPouchValAddOneConsider='true'
        }else{
            masterBrandDTO.isPouchValAddOneConsider='false'
        }
        if(brandObject.isPouchValAddTwoConsider==true){
            masterBrandDTO.isPouchValAddTwoConsider='true'
        }else{
            masterBrandDTO.isPouchValAddTwoConsider='false'
        }
        if(brandObject.isPouchValAddThreeConsider==true){
            masterBrandDTO.isPouchValAddThreeConsider='true'
        }else{
            masterBrandDTO.isPouchValAddThreeConsider='false'
        }
        if(brandObject.isPouchValAddFourConsider==true){
            masterBrandDTO.isPouchValAddFourConsider='true'
        }else{
            masterBrandDTO.isPouchValAddFourConsider='false'
        }
        if(brandObject.isPouchValAddFiveConsider==true){
            masterBrandDTO.isPouchValAddFiveConsider='true'
        }else{
            masterBrandDTO.isPouchValAddFiveConsider='false'
        }
        if(brandObject.isPouchFoodTypeConsider==true){
            masterBrandDTO.isPouchFoodTypeConsider='true'
        }else{
            masterBrandDTO.isPouchFoodTypeConsider='false'
        }
        if(brandObject.isPouchProductConsider==true){
            masterBrandDTO.isPouchProductConsider='true'
        }else{
            masterBrandDTO.isPouchProductConsider='false'
        }
        if(brandObject.isCartonBapNoConsider==true){
            masterBrandDTO.isCartonBapNoConsider='true'
        }else{
            masterBrandDTO.isCartonBapNoConsider='false'
        }
        if(brandObject.isCartonGradeConsider==true){
            masterBrandDTO.isCartonGradeConsider='true'
        }else{
            masterBrandDTO.isCartonGradeConsider='false'
        }
        if(brandObject.isCartonVariantConsider==true){
            masterBrandDTO.isCartonVariantConsider='true'
        }else{
            masterBrandDTO.isCartonVariantConsider='false'
        }
        if(brandObject.isCartonValAddOneConsider==true){
            masterBrandDTO.isCartonValAddOneConsider='true'
        }else{
            masterBrandDTO.isCartonValAddOneConsider='false'
        }
        if(brandObject.isCartonValAddTwoConsider==true){
            masterBrandDTO.isCartonValAddTwoConsider='true'
        }else{
            masterBrandDTO.isCartonValAddTwoConsider='false'
        }
        if(brandObject.isCartonValAddThreeConsider==true){
            masterBrandDTO.isCartonValAddThreeConsider='true'
        }else{
            masterBrandDTO.isCartonValAddThreeConsider='false'
        }
        if(brandObject.isCartonValAddFourConsider==true){
            masterBrandDTO.isCartonValAddFourConsider='true'
        }else{
            masterBrandDTO.isCartonValAddFourConsider='false'
        }
        if(brandObject.isCartonValAddFiveConsider==true){
            masterBrandDTO.isCartonValAddFiveConsider='true'
        }else{
            masterBrandDTO.isCartonValAddFiveConsider='false'
        }
        if(brandObject.isCartonFoodTypeConsider==true){
            masterBrandDTO.isCartonFoodTypeConsider='true'
        }else{
            masterBrandDTO.isCartonFoodTypeConsider='false'
        }
        if(brandObject.isCartonProductConsider==true){
            masterBrandDTO.isCartonProductConsider='true'
        }else{
            masterBrandDTO.isCartonProductConsider='false'
        }
        masterBrandDTO.isActive = brandObject.isActive;
        masterBrandDTO.createdAt = brandObject.createdAt;
        masterBrandDTO.updatedAt = brandObject.updatedAt;
        masterBrandDTO.createdUser = brandObject.createdUser;
        masterBrandDTO.updatedUser = brandObject.updatedUser;
        masterBrandDTO.versionFlag = brandObject.versionFlag;
        masterBrandDTO.displayBrandName = brandObject.displayBrandName;
        return masterBrandDTO;
      }
}